import { render, staticRenderFns } from "./CurrentLocationDescription.vue?vue&type=template&id=6fbf9c56&scoped=true&"
import script from "./CurrentLocationDescription.vue?vue&type=script&lang=js&"
export * from "./CurrentLocationDescription.vue?vue&type=script&lang=js&"
import style0 from "./CurrentLocationDescription.vue?vue&type=style&index=0&id=6fbf9c56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbf9c56",
  null
  
)

export default component.exports